// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"DataTable_paginationContainer__iG8lS","paginationToolbar":"DataTable_paginationToolbar__jUJ9F"};